import type { EventResult } from '~/types/interfaces'
import { useApiBase } from './useApiBase'

export interface CreateUserEventRequest {
  type: 'unlock' | 'gift'
  sceneId?: string
  key?: string
}

export interface CreateUserEventResponse {
  isSuccess: boolean
  results: EventResult[]
}

export function useEventApi() {
  const { apiBase, authenticatedFetch } = useApiBase()

  const triggerEvent = async (eventId: string, params?: object) => {
    return authenticatedFetch<{ results: EventResult[] }>(
      `${apiBase}/api/v1/events/trigger`,
      {
        method: 'POST',
        body: JSON.stringify({ eventId, params }),
      },
    )
  }

  const tryUnlockScene = async (sceneId: string, key: string) => {
    return authenticatedFetch<CreateUserEventResponse>(
      `${apiBase}/api/v1/user/event`,
      {
        method: 'POST',
        body: JSON.stringify({ type: 'unlock', sceneId, key }),
      },
    )
  }

  const redeemGiftKey = async (key: string) => {
    return authenticatedFetch<CreateUserEventResponse>(
      `${apiBase}/api/v1/user/event`,
      {
        method: 'POST',
        body: JSON.stringify({ type: 'gift', key }),
      },
    )
  }

  return { triggerEvent, tryUnlockScene, redeemGiftKey }
}
